import React from "react";
import Options from "./filter/options";
import Groups from "./filter/groups";
import Performance from "./filter/performance";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getProducts, clearAllOptions } from "../store/reducers/filterSlice";
import Loader from "./loader";
import FilterSwitcher from "./filter/filterSwitcher.jsx";

class Filter extends React.Component {
  state = {
    request: {},
    performanceOpen: true,
    loading: true,
    searched: "",
  };

  constructor(props) {
    super(props);
    this.state.request = { ...this.state.request, ...this.props.preselected };
    this.state.searched = window.location.search;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filter != this.props.filter) {
      this.setState({
        loading: false,
      });
    }
  }
  render() {
    const { t } = this.props;

    if (this.state.loading) {
      return <Loader />;
    }

    return (
      <>
        <FilterSwitcher
          filters={this.props.filters}
          activeFilter={this.props.activeFilter}
          switchFilter={this.props.switchFilter}
          powers={this.props.powers}
        />

        <form
          id={"filter" + this.props.id}
          className="filter-tab-content"
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <ul className="l1 filter">
            <li className="label">
              <h3
                className={this.state.isStandartsVisible1 ? "open" : "closed"}
                onClick={() =>
                  this.setState({
                    isStandartsVisible1: !this.state.isStandartsVisible1,
                  })
                }
              >
                {t("Filter by hydraulic power")}
              </h3>
            </li>
            <li
              className="first-item-container"
              data-filter-part="item-container"
            >
              {/* <span className={`radio-container ${this.state.performanceOpen ? ' selected' : ''}`} onClick={(e) => {this.setState({ performanceOpen: !this.state.performanceOpen })} }>
                <a>{t('Performance')}</a>
              </span> */}
              <div
                style={{
                  display: this.state.isStandartsVisible1 ? "block" : "none",
                }}
                className={`filter-controls-container l2 ${
                  this.state.performanceOpen
                    ? " selected standarts"
                    : " standarts"
                }`}
              >
                <Performance
                  powers={this.props.filter.powers}
                  ranges={this.props.filter.ranges}
                  selectedFrequency={this.state.request.frequency}
                  selectedRange={this.state.request.range}
                  selectedClass={this.state.request.class}
                />
              </div>
            </li>
            <div
              style={{
                display: this.state.isStandartsVisible1 ? "block" : "none",
              }}
              className={`filter-controls-container l2 ${
                this.state.performanceOpen
                  ? " selected standarts"
                  : " standarts"
              }`}
            >
              <li className="label label-button">
                <div>
                  <button
                    className="button-submit do-filter"
                    data-filter-part="submit"
                    onClick={() => {
                      this.props.requestPerformance();
                    }}
                  >
                    {t("Use")}
                  </button>
                </div>
              </li>
            </div>
            <li className="label">
              <h3
                className={this.state.isStandartsVisible2 ? "open" : "closed"}
                onClick={() =>
                  this.setState({
                    isStandartsVisible2: !this.state.isStandartsVisible2,
                  })
                }
              >
                {t("Other options")}
              </h3>
            </li>
            <div
              className="standarts"
              style={{
                display: this.state.isStandartsVisible2 ? "block" : "none",
              }}
            >
              <Groups
                groups={this.props.filter.groups}
                selectedGroups={this.state.request.groups}
              />
              <Options options={this.props.filter.options} />
            </div>
            <div>
              <button
                className="filter-reset-button"
                id="clear-all-filters1"
                onClick={() => this.props.clearAllOptions()}
              >
                {t("Reset all")}
              </button>
            </div>
          </ul>
        </form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    filter: state.filter.filter,
    request: state.filter.request,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      // setActiveFilter: args => dispatch => {
      //   dispatch(setActiveFilterId(args));
      //   dispatch(getFilter());
      //   dispatch(getProducts());
      // },
      // setRequest: args => dispatch => {
      //   dispatch(setRequest(args));
      // },
      requestPerformance: (args) => (dispatch) => {
        dispatch(getProducts());
      },
      clearAllOptions: () => (dispatch) => {
        dispatch(clearAllOptions());
        dispatch(getProducts());
      },
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Filter));
